import { render } from "./TemplateItem.vue?vue&type=template&id=40e5f502&scoped=true"
import script from "./TemplateItem.vue?vue&type=script&lang=js"
export * from "./TemplateItem.vue?vue&type=script&lang=js"

import "./TemplateItem.vue?vue&type=style&index=0&id=40e5f502&scoped=true&lang=css"

import exportComponent from "/Users/zvonkobiskup/Code/op3/wp-content/plugins/op-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e5f502"]])

export default __exports__